/**
 * The image hosts Next is allowed to resize and re-encode.
 *
 * Derived from the same file next.config.mjs uses for remotePatterns, deliberately -
 * two hand-kept lists would drift, and the cost of drift here is next/image throwing on
 * a host it doesn't recognise, which takes out the whole page rather than one photo.
 */
import { imageHosts } from '../../image-hosts.config.mjs';

export const OPTIMIZABLE_IMAGE_HOSTS = new Set(
  imageHosts.map((host: { hostname: string }) => host.hostname)
);
